import { BasketIntegrityTracking } from '../models/basketIntegrityTracking/basketIntegrityTracking';
import { DsiSession } from '../models/dsi/dsiSession';
import { CustomerSessionTracking } from '../models/session/customerSessionTracking';
import { FinalSession } from '../models/session/finalSession';
import { Session } from '../models/session/session';
import { SnapshotImage } from '../models/snapshot/snapshotImage';
import { CustomerTicket } from '../models/ticket/ticket';
import { zodForgivingSchema } from '../zod/forgivingSchema';
import { z } from 'zod';

export const DsiData = zodForgivingSchema(
    z.object({
        basketIntegrityTrackings: BasketIntegrityTracking.array(),
        customerSessionTracking: CustomerSessionTracking,
        dsiSession: DsiSession.nullish(),
        finalSession: FinalSession.nullish(),
        session: Session.nullish(),
        snapshotImages: SnapshotImage.array(),
        tickets: CustomerTicket.array(),
        /**
         * Absolute image URL per cart-image path referenced by a weight-without-scan alert, resolved by
         * dsi-backend-v2. Keyed by the path as stored on the alert, so one lookup serves both `snapshotPath` and
         * `snapshotBeforeEventPath` and no consumer builds a cart-image URL or branches on the storage generation.
         */
        weightWithoutScanImageUrls: z.record(z.string(), z.string()),
    }),
);
export type DsiData = z.infer<typeof DsiData>;
